import { ReservationTimer } from 'Views/Components/_HumanWritten/ReservationTimer/ReservationTimer';
import useAnytimeTicketSession from '../Hooks/useAnytimeTicketSession';
import { useAnytimeTicketStore } from '../State/AnytimeTicketContext';

export default function AnytimeTicketTimer() {
	const step = useAnytimeTicketStore(s => s.step);
	const transactionId = useAnytimeTicketStore(s => s.transactionId);
	const { handleTimerExpiry } = useAnytimeTicketSession();

	if (step !== 'payment' || !transactionId) {
		return null;
	}

	return <ReservationTimer transactionId={transactionId} onExpiry={handleTimerExpiry} variant="strip" />;
}
